const getIsPageNumberChanged = ({ query = "", currentPageNumber = 1 }) => {
  const searchParams = new URLSearchParams(query);
  const nextPageNumber = parseInt(searchParams.get("page"), 10) || 1;

  return nextPageNumber !== currentPageNumber;
};

export default getIsPageNumberChanged;
